export default __webpack_public_path__ + "static/media/1813.6104d0e0.png";